<div class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer-left">
      <span class="pl-2">Copyright 2026 - Connected ID Portal</span>
    </div>
  </div>
</div>
